import React, { memo } from "react";
import { PaginationDisplayControlProps } from "../../types";

const PaginationDisplayControl: React.FC<PaginationDisplayControlProps> = (
  props
) => {
  const { pagination } = props;

  return (
    <div className="mr-3 mt-3 xl:mt-0 text-sm text-gray-700 hidden xl:block">
        <span >Prikaz </span>
        <span className="font-medium">{pagination.pageNumber}</span> do{" "}
        <span className="font-medium">{pagination.pageSize}</span> od{" "}
        <span className="font-medium">{pagination.totalCount}</span> rezultata
    </div>
  );
};

export default memo(PaginationDisplayControl);
